var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 31,
    height: 31,
    rx: 4,
    transform: "translate(1 6)",
    fill: "#F3F8FF",
    stroke: "#0D5AE5",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14H9v14h6V14zm2 0v14h6V14h-6zm-9-2h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z",
    fill: "#0D5AE5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.912 9.281a6.187 6.187 0 0 1 0-2.562c.69.081 1.293-.148 1.49-.623C3.6 5.62 3.335 5.032 2.79 4.6A6.186 6.186 0 0 1 4.601 2.79c.43.546 1.019.81 1.495.613.475-.197.704-.8.623-1.49a6.186 6.186 0 0 1 2.562 0c-.081.69.148 1.293.623 1.49.476.197 1.064-.067 1.495-.613a6.186 6.186 0 0 1 1.812 1.812c-.546.43-.81 1.019-.613 1.495.197.475.8.704 1.49.623a6.186 6.186 0 0 1 0 2.562c-.69-.081-1.293.148-1.49.623-.197.476.067 1.064.613 1.495a6.187 6.187 0 0 1-1.812 1.812c-.43-.546-1.019-.81-1.495-.613-.475.197-.704.8-.623 1.49a6.186 6.186 0 0 1-2.562 0c.081-.69-.148-1.293-.623-1.49-.476-.197-1.064.067-1.495.613a6.186 6.186 0 0 1-1.812-1.812c.546-.43.81-1.019.613-1.495-.197-.475-.8-.704-1.49-.623zm1.112-1.15c.684.19 1.248.623 1.528 1.297.28.675.187 1.38-.163 1.998.06.064.121.125.185.185.617-.35 1.323-.442 1.998-.163.674.28 1.108.844 1.297 1.528.087.003.175.003.262 0 .19-.684.623-1.248 1.297-1.528.675-.28 1.38-.187 1.998.163.064-.06.125-.121.185-.185-.35-.617-.442-1.323-.163-1.998.28-.674.844-1.108 1.528-1.297a4.892 4.892 0 0 0 0-.262c-.684-.19-1.248-.623-1.528-1.297-.28-.675-.187-1.38.163-1.998a4.884 4.884 0 0 0-.185-.185c-.617.35-1.323.442-1.998.163-.674-.28-1.108-.844-1.297-1.528a4.938 4.938 0 0 0-.262 0c-.19.684-.623 1.248-1.297 1.528-.675.28-1.38.187-1.998-.163-.064.06-.125.121-.185.185.35.617.442 1.323.163 1.998-.28.674-.844 1.108-1.528 1.297a4.942 4.942 0 0 0 0 .262zM8 9.866a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732zm0-1.244a.622.622 0 1 0 0-1.244.622.622 0 0 0 0 1.244z",
    fill: "#0D5AE5",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSettingsIcon);
export default __webpack_public_path__ + "static/media/table-settings-icon.96f92dd433bfc96d8359cd0c707879a4.svg";
export { ForwardRef as ReactComponent };